const DATA_SENSITIVITY_LEVELS = {
    REQUIRES_ENHANCED_MONITORING: 'Requires Enhanced Monitoring',
    DISPLAY_ASSET_AND_ZONE: 'Display Asset and Zone',
    NO_ADDITIONAL_REQUIREMENTS: 'No Additional Requirements',
    REQUIRES_REDACTION: 'Requires Redaction',
    DISPLAY_ZONE_ONLY: 'Display Zone Only',
    REQUIRES_ENHANCED_COORDINATION: 'Requires Enhanced Coordination'
};

export default DATA_SENSITIVITY_LEVELS;
